import apiClient from "../../../../lib/api_client";

export const updateClient = async (clientPayload) => {
  const response = await apiClient.post(
    "/addNewClientWithMobileEmail",
    clientPayload
  );
  return response.data;
};
